/* eslint-disable no-plusplus */
import {
  nonEditable,
  textCell,
  headerCell
} from "../cells";
import { HEADER_ROW_ID, ROW_HEIGHT } from "../constants";
import { formatDecimalValues } from "@/utils/helpers";

export const CASH_IN_CHANGE_ROW_ID = "cashInChange";

function getHeaderRow(columns) {
  return {
    rowId: HEADER_ROW_ID,
    height: ROW_HEIGHT,
    cells: columns.map((column) => headerCell(column.label)),
  };
}

function getGroupRows(title, groups, columns) {
  if (groups?.length) {
    return [
      ...groups.map((item, index) => ({
        rowId: item.id,
        height: ROW_HEIGHT,
        cells: columns.map((column) => {
          const textCellArgs = {};

          if (column.formatter) {
            textCellArgs.text = item.vATType === "Input VAT Partial Recovery Calculation" && column.columnId === "vATAmountGL" ? `${formatDecimalValues(item[column.columnId])}%` : column.formatter(item[column.columnId], index);
          } else {
            textCellArgs.text = item[column.columnId] ?? "";
          }

          return nonEditable(textCell(textCellArgs), item.vATType === "Input VAT Partial Recovery Calculation" ? "total-row-credit" : "");
        }),
      }))
    ];
  }
  return [];
}

export function getVATSummaryRows({
  data,
  columns
}) {

  if (!data) {
    return [];
  }

  const index = data.data.findIndex((item) => item.vATType === "Input VAT Partial Recovery Calculation");

  // If the item is found, remove it and push to the end of the array
  if (index !== -1) {
    const [item] = data.data.splice(index, 1);
    data.data.push(item);
  }

  return [getHeaderRow(columns), ...getGroupRows("Total", data.data, columns)];
}
